// src/components/mainnavbar.js

import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { navLinks } from '../views/data';
import './mainnavbar.css';

const MainNavbar = () => {
  return (
    <Navbar expand="lg" bg="light" variant="light" sticky="top" className="mainnavbar">
      <Container>
        <Navbar.Brand href="/">
          <img alt="Company Logo" src="/rma_big_logo.png" className="mainnavbar-logo" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar-nav" />
        <Navbar.Collapse id="main-navbar-nav">
          <Nav className="ms-auto">
            {navLinks.map((navItem) => (
              <LinkContainer key={navItem.id} to={navItem.path}>
                <Nav.Link>{navItem.label}</Nav.Link>
              </LinkContainer>
            ))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default MainNavbar;
